module.exports = __webpack_public_path__ + "static/fall-leaves-7c1d177490f4f4ef4e350b81eabf560f.jpg";